module.exports = __webpack_public_path__ + "img/cm.5799ad4c.svg";